const state = {
    code_challenge: '',
    nav_bar_visible: true
}
const getters = {
      code_challenge:(state)=> {
        return state.code_challenge;
      },
        nav_bar_visible:(state)=> {
        return state.nav_bar_visible;
      }
}
const mutations = {
set_code_challenge  (state, value)  {
        state.code_challenge = value;
      },
      set_nav_bar_visible (state, value) {
        state.nav_bar_visible = value;
      }
}
// actions
const actions = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
